var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.9987V4.53203C13.3333 3.41193 13.3333 2.85187 13.1153 2.42405C12.9236 2.04773 12.6176 1.74176 12.2413 1.55002C11.8134 1.33203 11.2534 1.33203 10.1333 1.33203H5.86663C4.74652 1.33203 4.18647 1.33203 3.75864 1.55002C3.38232 1.74176 3.07636 2.04773 2.88461 2.42405C2.66663 2.85187 2.66663 3.41193 2.66663 4.53203V11.4654C2.66663 12.5855 2.66663 13.1455 2.88461 13.5733C3.07636 13.9497 3.38232 14.2556 3.75864 14.4474C4.18647 14.6654 4.74652 14.6654 5.86663 14.6654H7.99996M9.33329 7.33203H5.33329M6.66663 9.9987H5.33329M10.6666 4.66536H5.33329M12 13.9987V9.9987M9.99996 11.9987H14",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus02);
export default __webpack_public_path__ + "static/media/file-plus-02.6a1b8d95491bd74a19c37c1bd6bb4d0a.svg";
export { ForwardRef as ReactComponent };